import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useQuery = <TQueryParams extends Record<string, string | undefined>>() => {
  const { search } = useLocation();
  return useMemo(() => Object.fromEntries(new URLSearchParams(search)) as TQueryParams, [search]);
};
